import { Routes } from '@angular/router';

// Component
import { AuthGuard } from '@core/auth/route-auth.guard';
import { LayoutComponent } from './layouts/layout.component';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/dashboards/dashboard.routes'),
  },
];
